<template>
    <BannerComponent title="Nuestros Servicios" show="false" paragraph="Ofrecemos soluciones integrales de marketing digital para potenciar tu negocio, desde branding y redes sociales hasta desarrollo web y edición de contenido. Impulsa tu presencia online con estrategias efectivas y creativas." colorTitle="black"
        colorParagraph="gray" backgroundColor="white" urlImg="" urlImgDark="" aligmentContent="center"
        buttonLabel="Click aquí" buttonBackground="#1f8cc6" buttonColor="white" buttonLink="" paddingY="80px" marginB="0" />
    <PreviewPage2Component title="Nuestros Servicios" description=""  backgroundColor="transparent" />
</template>
<!-- urlImg="https://i.pinimg.com/564x/e2/f9/31/e2f931b19ed72d82e04f6d0aaf9d98e4.jpg" -->

<script>
import BannerComponent from '../components/Banner-component.vue';
import PreviewPage2Component from '../components/PreviewPage2-component.vue';

export default {
    name: 'ServicesPage',
    components: {
        BannerComponent,
        PreviewPage2Component
    }
}
</script>